import React from 'react';
import Instanoti from 'instanoti-js';
import { toast } from 'react-toastify';
import isMobile from 'ismobilejs';
import Registry from 'registry';

import Notification from '../components/notification/ItemPopupNotification';

import {
    receiveInstantNotification,
    RECEIVE_INSTANT_NOTIFICATION
} from 'reducers/memberNotificationList';

import { receiveMemberVirtualGift } from 'reducers/memberVirtualGifts';
import { getMemberMessageList } from 'reducers/memberMessageList';
import { getMemberGuestbook } from 'reducers/memberGuestbook';
import { getWallMaterialAction } from 'reducers/wallMaterials';

import { getProfile } from '../backend-helpers/profile';
import { getWallMaterial } from '../backend-helpers/wallMaterial';
import { getMemberVirtualGifts } from '../backend-helpers/memberVirtualGifts';

import {
    LOGIN_SUCCESS,
    SET_CURRENT_USER,
    getCurrentUser,
    setCurrentUserCounters,
} from 'reducers/currentUser';

import { newMemberFollowed } from 'reducers/memberFollowed'

const socketMiddleware = function socketMiddleware(store) {
    let socket;
    let toastId;
    return function (next) {
        return function (action) {
            const WSS_URL = Registry.get('WSS_URL');
            let wss_url = WSS_URL.match(/^wss:/) ? WSS_URL : Registry.get('PUBLIC_URL').replace(/^https?:/, "wss:") + WSS_URL;
            switch(action.type) {
                case LOGIN_SUCCESS:
                case SET_CURRENT_USER: {
                    socket = new Instanoti({
                        server_uri: wss_url,
                        on_open: data => {
                            console.log("Websocket connected")
                        },
                        on_close: data => {
                            console.log("Websocket disconnected")
                        },
                        on_error: err => {
                            console.log("Websocket error", err)
                        },
                        on_counter: data => {
                            store.dispatch(setCurrentUserCounters(data));
                        },
                        on_tip: data => {
                            store.dispatch(receiveInstantNotification(data));
                        },
                        on_new_follower: data => {
                            store.dispatch(receiveInstantNotification(data));
                            const { data: { meta: { user: { id, nick }}}} = data;
                            getProfile({id, nick})
                                .then(res => store.dispatch(newMemberFollowed(res.user)))
                                .catch(err => console.error(err.message));
                        },
                        on_gift: data => {
                            store.dispatch(receiveInstantNotification(data));
                            const { data: { entity_id }} = data;
                            getMemberVirtualGifts({ id: entity_id })
                                .then(res => store.dispatch(receiveMemberVirtualGift(res.data)))
                                .catch(err => console.error(err.message));
                        },
                        on_message: data => {
                            // check if conversation with this user opened
                            let id;
                            const state = store.getState();
                            if (state.router) {
                                const { router: { location: { pathname }}} = state;
                                id = pathname.split("/").pop();
                            }
                            if (+id !== data.data.meta.user.id) {
                                store.dispatch(receiveInstantNotification(data, true));
                                store.dispatch(getMemberMessageList({ conversation_id: data.data.meta.user.id}));
                            }
                        },
                        on_membership_gift: data => {
                            store.dispatch(receiveInstantNotification(data));
                            store.dispatch(getCurrentUser());
                        },
                        on_membership_gift_public: data => {
                            store.dispatch(receiveInstantNotification(data));
                        },
                        on_guestbook_message: data => {
                            store.dispatch(receiveInstantNotification(data));
                            store.dispatch(getMemberGuestbook())
                        },
                        on_wall: data => {
                            const { currentUser } = store.getState();
                            if ((currentUser.id !== data.data.meta.user.id)
                                && currentUser.notification_settings.wall_notify.site) {
                                    store.dispatch(receiveInstantNotification(data));
                            }
                            getWallMaterial(data.data.entity_id)
                                .then(res => store.dispatch(getWallMaterialAction(res.data)))
                                .catch(err => console.error(err.message));
                        },
                        on_followed_user_is_online: data => {
                            store.dispatch(receiveInstantNotification(data, true));
                        },
                        on_new_personal_room: data => {
                            store.dispatch(receiveInstantNotification(data, true));
                        },
                        on_new_showroom: data => {
                            store.dispatch(receiveInstantNotification(data, true));
                        },
                        on_user_membership_expired: data => {
                            store.dispatch(receiveInstantNotification(data));
                        },
                        on_user_membership_almost_expired: data => {
                            store.dispatch(receiveInstantNotification(data));
                        },
                        on_stream_record_error: data => {
                            store.dispatch(receiveInstantNotification(data));
                        },
                        reconnect: true
                    });
                    break;
                }
            case RECEIVE_INSTANT_NOTIFICATION:
                if (!isMobile.any) {
                    if (!toastId) {
                        toastId = toast(
                            <Notification data={action.data} />,
                            { onClose: () => toastId = undefined }
                        );
                    } else {
                        toast.update(toastId, {
                            render: <Notification data={action.data} />
                        });
                    }
                }
            }
        return next(action);
      };
    };
  };

export default socketMiddleware;



// WEBPACK FOOTER //
// ./src/middleware/socketMiddleware.js